import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import DomHolder from '../common/DomHolder';

export default class AnimatedErrorMessage extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    in: PropTypes.bool,
    enterTimeout: PropTypes.number,
    exitTimeout: PropTypes.number,
    onScrollHeightUpdate: PropTypes.func,
  };

  static defaultProps = {
    in: false,
    enterTimeout: 300,
    exitTimeout: 300,
    onScrollHeightUpdate: () => {},
  };

  constructor(props) {
    super(props);

    this.errorMsgRef = React.createRef();
    this.errorMsgContentRef = React.createRef();
  }

  handleEnter = () => {
    if (!this.errorMsgRef.current || !this.errorMsgContentRef.current) return;

    this.errorMsgRef.current.style.opacity = '0';
    this.errorMsgRef.current.style.height = '0px';

    this.errorMsgRef.current.getBoundingClientRect();

    this.errorMsgRef.current.style.height = `${this.errorMsgContentRef.current.clientHeight}px`;
    this.errorMsgRef.current.style.opacity = '1';
  };

  handleEntered = () => {
    if (!this.errorMsgRef.current) return;
    this.errorMsgRef.current.style.height = '';
    this.errorMsgRef.current.style.opacity = '';
    this.props.onScrollHeightUpdate();
  };

  handleExit = () => {
    if (!this.errorMsgRef.current || !this.errorMsgContentRef.current) return;

    this.errorMsgRef.current.style.opacity = '1';
    this.errorMsgRef.current.style.height = `${this.errorMsgContentRef.current.clientHeight}px`;

    this.errorMsgRef.current.getBoundingClientRect();
  };

  handleExiting = () => {
    this.errorMsgRef.current.style.height = '0px';
    this.errorMsgRef.current.style.opacity = '0';
  };

  handleExited = () => {
    if (!this.errorMsgRef.current) return;
    this.errorMsgRef.current.style.height = '';
    this.errorMsgRef.current.style.opacity = '';
    this.props.onScrollHeightUpdate();
  };

  render() {
    const { children, in: active, enterTimeout, exitTimeout } = this.props;

    return (
      <Transition
        in={active}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: enterTimeout, exit: exitTimeout }}
        nodeRef={this.errorMsgRef}
        onEnter={this.handleEnter}
        onEntered={this.handleEntered}
        onExit={this.handleExit}
        onExiting={this.handleExiting}
        onExited={this.handleExited}
      >
        <div className="ui-error-msg" ref={this.errorMsgRef}>
          <div className="ui-error-msg-content" ref={this.errorMsgContentRef}>
            <DomHolder>
              {active && children}
            </DomHolder>
          </div>
        </div>
      </Transition>
    );
  }
}
